import { useCallback, useMemo, Fragment } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { numberFormatter } from '../../utils/formatter';

import { ColorsEnum, Text, Container, Title, Scores, Position } from './styles';
import { LeaderboardType } from '../../types/entities';

type LeaderboardPropTypes = {
  borderless?: boolean;
  highlightPosition?: number;
  results?: LeaderboardType[];
  small?: boolean;
};

export const Leaderboard = ({
  borderless,
  highlightPosition,
  results,
  small,
}: LeaderboardPropTypes) => {
  const { language, languageSelector } = useLanguage();

  const maxLengthResults = useMemo<LeaderboardType[]>(() => {
    const getIndexes = () => {
      return [0, 9];
    };
    const indexes = getIndexes();

    return results?.slice(...indexes) || [];
  }, [results, highlightPosition]);

  const getColors = useCallback(
    (position: number) => {
      if (highlightPosition) {
        return {
          positionColor: position !== highlightPosition ? ColorsEnum.GRAY : ColorsEnum.BLACK,
          scoreColor: position !== highlightPosition ? ColorsEnum.GRAY : ColorsEnum.DARK_BLUE,
        };
      }

      return {
        positionColor: ColorsEnum.BLACK,
        scoreColor: ColorsEnum.DARK_BLUE,
      };
    },
    [highlightPosition],
  );

  return (
    <Container borderless={borderless} small={small}>
      <Title>{language.leaderboard}</Title>
      <Scores>
        {maxLengthResults.map(({ position, playerName, points }) => (
          <Fragment key={position}>
            <Position color={getColors(position).positionColor}>{position}.</Position>
            <Text
              color={
                highlightPosition && position !== highlightPosition ? ColorsEnum.GRAY : undefined
              }>
              {playerName}
            </Text>
            <Text color={getColors(position).scoreColor}>
              {numberFormatter(languageSelector).format(points)}
            </Text>
          </Fragment>
        ))}
      </Scores>
    </Container>
  );
};
